import ConfirmationModalWrapper from "app/components/ConfirmationModalWrapper";
import Pill from "app/components/Pill";
import React from "react";
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectButtonLoading, selectTagDeleteModal, selectTagsForm } from "./redux/selector";
import { actions } from "./redux/slice";

type TagRemoveWrapperProps = {
  onClose?: () => void;
};

const TagRemoveWrapper: React.FC<TagRemoveWrapperProps> = ({ onClose }) => {
  const dispatch = useDispatch();
  const buttonLoading = useSelector(selectButtonLoading);
  const form = useSelector(selectTagsForm);
  const shownModal = useSelector(selectTagDeleteModal);

  const handleClose = () => {
    dispatch(actions.toggleDeleteModal(false));
    onClose?.();
  };
  const onSave = () => {
    dispatch(actions.deleteTag({ id: form._id, callback: () => { handleClose() } }));
  };

  if (!shownModal) {
    return null;
  }

  return createPortal(
    <ConfirmationModalWrapper
      onClose={handleClose}
      onSave={onSave}
      title="Delete Tag"
      submitText="Delete"
      cancelText="Cancel"
      loading={buttonLoading}
    >
      <div className="px-6 py-4">
        <div className="flex flex-wrap items-center text-sm font-normal text-secondary">
          <span className="text-sm font-normal text-secondary">
            Are you sure that you want to delete tag
          </span>
          <Pill
            backgroundColor={form?.color}
            name={form?.title}
            className="px-1.5 py-[2px] text-[10px] leading-[18px] font-medium text-black mx-1"
          />
          ?
        </div>
      </div>
    </ConfirmationModalWrapper>,
    document.body,
  );
};

export default TagRemoveWrapper;
